import { useEffect } from "react";
import {
  useWebInfoDetail,
  useWebInfoSave,
} from "../../../hooks/api/web-info/hooks";
import { Facebook, Instagram, Twitter } from "lucide-react";
import toast from "react-hot-toast";

import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { Form, Input, Button } from "antd";
import * as yup from "yup";

const schema = yup.object({
  facebook: yup.string().url("Invalid URL").optional(),
  instagram: yup.string().url("Invalid URL").optional(),
  twitter: yup.string().url("Invalid URL").optional(),
});

type SocialFormType = yup.InferType<typeof schema>;

const SocialLinksForm = () => {
  const { data: details } = useWebInfoDetail("SOCIAL");

  const { mutate: saveForm, isPending } = useWebInfoSave({
    onSuccess: () => toast.success("Social links updated"),
    onError: (error: any) =>
      toast.error(error?.message || "Something went wrong"),
  });

  const { control, handleSubmit, reset } = useForm<SocialFormType>({
    resolver: yupResolver(schema) as any,
    defaultValues: {
      facebook: "",
      instagram: "",
      twitter: "",
    },
  });

  useEffect(() => {
    if (details?.data?.social_links) {
      reset(details.data.social_links);
    }
  }, [details?.data?._id]);

  const socialLinks = [
    {
      name: "facebook",
      label: "Facebook",
      icon: <Facebook size={18} />,
    },
    {
      name: "instagram",
      label: "Instagram",
      icon: <Instagram size={18} />,
    },
    {
      name: "twitter",
      label: "Twitter",
      icon: <Twitter size={18} />,
    },
  ];

  const onSubmit = (values: SocialFormType) => {
    saveForm({
      type: "SOCIAL",
      social_links: values,
       ...(details?.data?._id && { _id: details.data._id }),
    });
  };

  return (
    <div className="w-full mx-auto ">
      <Form layout="vertical" onFinish={handleSubmit(onSubmit)}>
        <div className="p-6 bg-[#fdf0e3] rounded-xl  ">

        {socialLinks.map((item) => (
          <div
            key={item.name}
            className="flex items-center gap-4 mb-4 "
          >
            {/* ICON BOX */}
            <div className="flex max-w-[150px] w-full items-center gap-x-5">

            <div className="w-10 h-10 flex items-center justify-center bg-[#ffc58a] rounded-full text-orange-600 shadow-md">
              {item.icon}
            </div>

             <h2 className="text-[15px] font-medium text-gray-700 mb-1">
                {item.label}
              </h2>
            </div>

            {/* Label + Input */}
            <div className="flex flex-col flex-1">
             

              <Controller
                name={item.name as keyof SocialFormType}
                control={control}
                render={({ field, fieldState }) => (
                  <>
                    <Input {...field} placeholder="Link" />

                    {fieldState.error && (
                      <span className="text-red-500 text-xs mt-1">
                        {fieldState.error.message}
                      </span>
                    )}
                  </>
                )}
              />
            </div>
          </div>
        ))}
        </div>



        <div className="mt-6 flex gap-4">
          <Button
            type="primary"
            htmlType="submit"
            loading={isPending}
            className="bg-primary px-10"
          >
            {isPending ? "Saving..." : "Save"}
          </Button>

         
        </div>
      </Form>
    </div>
  );
};

export default SocialLinksForm;
